import { Mark, mergeAttributes } from '@tiptap/react';

export interface ShimmerOptions {
  HTMLAttributes: Record<string, unknown>;
}

declare module '@tiptap/react' {
  interface Commands<ReturnType> {
    shimmer: {
      /**
       * Set a shimmer mark
       */
      setShimmer: (attributes?: { speed?: string }) => ReturnType;
      /**
       * Toggle a shimmer mark
       */
      toggleShimmer: (attributes?: { speed?: string }) => ReturnType;
      /**
       * Unset a shimmer mark
       */
      unsetShimmer: () => ReturnType;
    };
  }
}

export const ShimmerExtension = Mark.create<ShimmerOptions>({
  name: 'shimmer',

  addOptions() {
    return {
      HTMLAttributes: {
        class: 'shimmer',
      },
    };
  },

  addAttributes() {
    return {
      speed: {
        default: null,
        renderHTML: (attributes) => {
          if (!attributes.speed) {
            return {};
          }

          return {
            style: `--shimmer-animation-duration: ${attributes.speed}`,
          };
        },
        parseHTML: (element) =>
          element.style.getPropertyValue('--shimmer-animation-duration'),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[class="shimmer"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },

  addCommands() {
    return {
      setShimmer:
        (attributes) =>
        ({ commands }) => {
          return commands.setMark(this.name, attributes);
        },
      toggleShimmer:
        (attributes) =>
        ({ commands }) => {
          return commands.toggleMark(this.name, attributes);
        },
      unsetShimmer:
        () =>
        ({ commands }) => {
          return commands.unsetMark(this.name);
        },
    };
  },
});
